import { LegalLayout } from "@/components/LegalLayout";

export default function DeleteAccountPage() {
  return (
    <LegalLayout
      title="Delete Your Account"
      lastUpdated="June 2026"
      testId="delete-account-page"
    >
      <p>
        You can permanently delete your <strong>Brimi AI</strong> account and the
        learning data we hold about you at any time. There are two ways to do this:
      </p>

      <h2>Option 1 — Request via email (recommended)</h2>
      <ol>
        <li>
          Send an email to <a href="mailto:hello@brimi.in">hello@brimi.in</a>
          {" "}from the same email address you used to sign up.
        </li>
        <li>
          Use the subject line: <strong>Delete my Brimi account</strong>.
        </li>
        <li>
          Optional — tell us the reason (helps us improve, totally up to you).
        </li>
      </ol>
      <p>
        We confirm receipt within 24 hours and complete the deletion within{" "}
        <strong>7 business days</strong>. You will receive a final confirmation
        email when it&apos;s done.
      </p>

      <h2>Option 2 — Delete from inside the app</h2>
      <ol>
        <li>Sign in to Brimi AI (web or Android app).</li>
        <li>
          Go to <strong>Profile → Account settings → Delete account</strong>{" "}
          <em>(coming soon — for now please use Option 1)</em>.
        </li>
      </ol>

      <h2>What gets deleted</h2>
      <ul>
        <li>Your account record (name, email, password hash, selected class).</li>
        <li>All chat sessions and messages with the AI tutor.</li>
        <li>All quiz attempts, past-paper attempts and score history.</li>
        <li>All uploaded notes / files you added to your chapters.</li>
        <li>Saved preferences and authentication tokens.</li>
      </ul>

      <h2>What we keep (and why)</h2>
      <p>
        Under Indian tax and accounting law we are required to retain certain
        transaction records even after account deletion. Specifically:
      </p>
      <ul>
        <li>
          <strong>Payment records</strong> (Razorpay transaction ID, plan, date,
          amount) — retained for up to <strong>8 years</strong> as required by
          the Income Tax Act and CGST rules. These records are anonymised — they
          no longer carry your name or email after deletion.
        </li>
        <li>
          <strong>Aggregated, non-identifiable analytics</strong> (e.g. &ldquo;how many
          students attempted Class X Chapter 3 in Feb 2026&rdquo;) — retained
          indefinitely. This data cannot be linked back to you.
        </li>
      </ul>

      <h2>Active subscription?</h2>
      <p>
        Deleting your account also cancels any active subscription. We do{" "}
        <em>not</em> automatically refund the unused portion — if you want a
        pro-rata refund, please request it in the same email and we will process
        it through Razorpay (typically reaches your account in 5–7 working days
        for cards, instantly for UPI).
      </p>

      <h2>Questions?</h2>
      <p>
        Write to us at{" "}
        <a href="mailto:hello@brimi.in">hello@brimi.in</a>. We aim to reply
        within 24 hours on working days.
      </p>
    </LegalLayout>
  );
}
